module.exports = __webpack_public_path__ + "img/icon-minus.ccb424bc.svg";